import Vue from 'vue'
import Router from 'vue-router'
import StarterPage from './components/StarterPage.vue'
import QuestionPage from './components/QuestionPage.vue'
import MatchPage from './components/MatchPage.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: StarterPage
    },
    {
      path: '/:q_id/:answers',
      name: 'questions',
      component: QuestionPage,
      props: true,
    },
    {
      path: '/match/:answers/:product',
      name: 'match',
      component: MatchPage,
      props: true,
    },
  ]
})
